import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/lib/cn'

type Variant = 'ghost' | 'chip'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  variant?: Variant
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, variant = 'ghost', className, ...rest }, ref) => (
    <button
      ref={ref}
      className={cn('btn', `btn--${variant}`, className)}
      {...rest}
    >
      {children}
    </button>
  ),
)
Button.displayName = 'Button'
